import { preloadUrl } from '../functions.js';

export default function MainModule(element) {

    let audioElement = document.querySelector('.clicksound');
    let currentCursorVideo;
    let $cursor;
    let $cursorVideo;
    let $pageTrans = document.querySelector('.pagetrans');

    function initItemsWithBolita() {
        function onEnter(event) {
            event.target.style.setProperty('--offset-x', event.offsetX + 'px');
            event.target.style.setProperty('--offset-y', event.offsetY + 'px');
        }
        document.querySelectorAll('.link1, .btn, .portfolio__item').forEach((elm) => {
            elm.addEventListener('mouseenter', onEnter);
        });
    }

    function initDelayedClick() {
        document.querySelectorAll('.delayed-click').forEach((elm) => {
            elm.addEventListener('click', delayedClickWithSound);
        });
    }

    function delayedClickWithSound(event) {
        // Si el usuario tiene presionaro Ctrl o Cmd, no hacemos nada raro.
        if (event.metaKey || event.ctrlKey) { 
            return true;
        }

        let target = event.currentTarget || event.target;

        MainModule.playSound();

        if (target.tagName !== 'A') { // Si NO es un A (posiblemente botón), no hacemos nada más.
            return true;
        }

        MainModule.showPageTransition();

        // Esperamos a que se termine de reproducir el sonido para redirigir el destino
        event.preventDefault();
        event.stopPropagation();

        let href = target.href;
        setTimeout(function() {
            location.href = href;
        }, 500);
         
        return true;
    }

    function initCursor() {

        if (window.matchMedia('(pointer: coarse)').matches) { // Solo aplicamos en mobile
            return;
        }

        $cursor = document.querySelector('.cursor');
        $cursorVideo = $cursor.querySelector('.cursor__video');

        document.body.addEventListener('mousemove', function(event) {
            gsap.to($cursor, {top:  event.clientY, duration: 0.4, ease: 'back.out(1.7)'});
            gsap.to($cursor, {left: event.clientX, duration: 0.4, ease: 'back.out(1.7)'});
            if (!currentCursorVideo) {
                $cursorVideo.src = '';
                $cursorVideo.pause();
                $cursor.classList.remove('cursor--hasvideo');
            } else if (currentCursorVideo && $cursorVideo.src !== currentCursorVideo) {
                $cursorVideo.src = currentCursorVideo;
                $cursorVideo.play();
                $cursor.classList.add('cursor--hasvideo');
            }
        });

        document.querySelectorAll('*[data-cursor]').forEach(function (elem) {

           preloadUrl(elem.getAttribute('data-cursor'));

            elem.addEventListener('mouseenter', function(event) {
                if (event.currentTarget !== event.target) { return; }
                currentCursorVideo = event.target.getAttribute('data-cursor');
            });
            elem.addEventListener('mouseleave', function(event) {
                if (event.currentTarget !== event.target) { return; }
                currentCursorVideo = null;
            });
        });
    }

    function showConsoleLog() {
        console.log('%cMade with ❤️ by Kodens', 'font-size: 26px; font-weight: bold; line-height: 1.6; font-family: Montserrat, sans-serif;');
        console.log('https://kodens.es');
    }

    MainModule.playSound = function() {
        audioElement.play();
    }

    MainModule.showPageTransition = function() {
        $pageTrans.style.display = 'flex';
        setTimeout(function() {
            $pageTrans.classList.add('pagetrans--visible');
        }, 20)
    }
    MainModule.hidePageTransition = function() {
        $pageTrans.classList.remove('pagetrans--visible');
        setTimeout(function() {
            $pageTrans.style.display = 'none';
        }, 500);
    }

    initItemsWithBolita();
    initDelayedClick();
    initCursor();
    showConsoleLog();
    MainModule.hidePageTransition();

    return this;

}

